<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableAlarmContactGroupDate"
      style="width: 100.1%;"
    >
      <!-- 配置 -->
      <template slot-scope="{ row, index }" slot="configure">
        <Button
          type="info"
          size="small"
          v-hasPermission="['alarmContact:group:config']"
          @click="alarmContactConfiguration(row)"
          >{{ $t("alarm_contact.contactGroupConfig") }}</Button
        >
      </template>
      <template slot-scope="{ row, index }" slot="operationLog">
        <Button
          type="success"
          size="small"
          v-hasPermission="['alarm_contact:AlarmContact:group_log']"
          @click="rowClick(row)"
          >{{ $t("alarm_contact.operationLog") }}</Button
        >
      </template>
      <!-- 删除 -->
      <template slot-scope="{ row, index }" slot="delete"></template>
    </Table>
    <alert-rule-operation-log
      v-if="alertRuleOperationLogVisible"
      ref="alertRuleOperationLog"
    ></alert-rule-operation-log>
    <!-- 删除报警联系人组模式框 -->
    <Modal
      v-model="alarmContactGroupDelmodal"
      width="360"
      :mask-closable="false"
    >
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ alarmContactGroupName }} ?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeAlarmContactGroup()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}
        </Button>
      </div>
    </Modal>
    <!-- 编辑报警联系人组模式框 -->
    <Modal
      v-model="alarmContactGroupEditmodal"
      :title="$t('alarm_contact.editContact')"
      :loading="loading"
      :mask-closable="false"
      @on-ok="editAlarmContactGroupSubmit('alarmContactGroupEditForm')"
      @on-cancel="editAlarmContactGroupReset('alarmContactGroupEditForm')"
      :okText="$t('alarms.common.edit')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="alarmContactGroupEditForm"
        :model="alarmContactGroupEditForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 公司 -->
        <FormItem :label="$t('alarm_contact.companyName')" prop="companyId">
          <div>{{ this.companyName }}</div>
        </FormItem>

        <!-- 联系人组名称 -->
        <FormItem :label="$t('alarm_contact.contactGroupName')" prop="name">
          <Input
            v-model="alarmContactGroupEditForm.name"
            style="width:300px;"
          />
        </FormItem>

        <!-- 默认联系人组 -->
        <FormItem :label="$t('alarm_contact.defaultContact')" prop="isDefault">
          <RadioGroup v-model="alarmContactGroupEditForm.isDefault">
            <Radio
              v-for="list in isDefaultList"
              :label="list.isDefault"
              :key="list.value"
              >{{ list.label }}</Radio
            >
          </RadioGroup>
        </FormItem>

        <!-- 描述 -->
        <FormItem :label="$t('alarm_contact.description')" prop="description">
          <Input
            v-model="alarmContactGroupEditForm.description"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>
      </Form>
      <!--

        @on-ok="editAlarmContactGroupSubmit('alarmContactGroupEditForm')"
      @on-cancel="editAlarmContactGroupReset('alarmContactGroupEditForm')"
    :okText="$t('alarms.common.edit')"
      :cancelText="$t('alarms.common.cancel')"
       -->
      <!-- <div slot="footer">
        <Button
          @click="editAlarmContactGroupReset('alarmContactGroupEditForm')"
          >{{ $t("alarms.common.cancel") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="['alarm_contact:AlarmContact:update']"
          @click="editAlarmContactGroupSubmit('alarmContactGroupEditForm')"
          :disabled="isDisable"
          >{{ $t("alarms.common.edit") }}</Button
        >
      </div> -->
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import AlertRuleOperationLog from "../../monitor/common/AlertRuleOperationLog.vue";
var tableAlarmContactGroupVue = {};
export default {
  name: "TableAlarmContactGroup",
  components: {
    AlertRuleOperationLog
  },
  data() {
    return {
      alertRuleOperationLogVisible: false,
      companyName: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      alarmContactGroupDelmodal: false,
      isDisable: false,
      modal_loading: false,
      loading: true,
      alarmContactGroupEditmodal: false,
      isDefaultType: [this.$t("common.no"), this.$t("common.yes")],
      val: "",
      alarmContactGroupName: "",
      alarmContactGroupEditForm: {
        name: "",
        description: "",
        isDefault: ""
      },
      isDefaultList: [
        {
          label: this.$t("alarm_contact.yes"),
          value: "is",
          isDefault: "1"
        },
        {
          label: this.$t("alarm_contact.no"),
          value: "no",
          isDefault: "0"
        }
      ],
      columns: [
        {
          title: this.$t("alarm_contact.companyName"),
          key: "companyName"
        },
        {
          title: this.$t("alarm_contact.contactGroupName"),
          key: "name"
        },
        {
          title: this.$t("common.configure"),
          slot: "configure"
        },
        {
          title: this.$t("alarm_contact.default"),
          key: "isDefault"
        },
        {
          title: this.$t("alarm_contact.description"),
          key: "description"
        },
        {
          title: this.$t("CloudTrailSecurity.operationLog"),
          slot: "operationLog"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  style: {
                    "margin-right": "5px"
                  },
                  on: {
                    click: () => {
                      this.alarmContactGroupEditmodal = true; //编辑弹出层
                      this.alarmContactGroupEditForm.id = params.row.id;
                      // 联系人组名称
                      this.alarmContactGroupEditForm.name = params.row.name;
                      // 默认联系人组
                      // 是
                      if (params.row.isDefault == this.$t("common.yes")) {
                        this.alarmContactGroupEditForm.isDefault = "1";
                      }
                      // 否
                      else if (params.row.isDefault == this.$t("common.no")) {
                        this.alarmContactGroupEditForm.isDefault = "0";
                      }
                      // 描述
                      this.alarmContactGroupEditForm.description =
                        params.row.description;
                      // 公司名称
                      this.companyName = params.row.companyName;
                    }
                  }
                },
                this.$t("alarm_contact.edit")
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.doDelete(params.index);
                      this.alarmContactGroupDelmodal = true;
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array("alarm_contact:AlarmContactGroup:delete")
                    }
                  ]
                },
                this.$t("alarm_contact.del")
              )
            ])
          }
        }
      ],
      ruleValidate: {
        name: [
          { required: true, message: "请输入联系人组名称", trigger: "blur" }
        ],
        isDefault: [
          { required: true, message: "请选择默认联系人组", trigger: "change" }
        ],
        description: [
          { required: true, message: "请输入描述", trigger: "blur" }
        ]
      },
      tableAlarmContactGroupDate: []
    };
  },
  beforeCreate: function() {
    tableAlarmContactGroupVue = this;
  },
  mounted: function() {
    tableAlarmContactGroupVue.getAlarmContactGroupData();
  },
  methods: {
    // 操作日志
    /****************************************************/
    rowClick: function(row) {
      this.alertRuleOperationLogVisible = true;
      this.$nextTick(function() {
        this.$refs.alertRuleOperationLog.getContactGroupOperationLogData(row);
      });
    },
    // 点击联系人配置
    alarmContactConfiguration: function(row) {
      this.$router.push({
        path: "/alarmContact/contactConfiguration",
        query: { id: row.id }
      });
    },
    showAll: function() {
      tableAlarmContactGroupVue.getAlarmContactGroupData();
    },
    // 分页显示数据
    /****************************************************/
    getAlarmContactGroupData: function() {
      // 获取AlarmContactGroupSearch里面的搜索内容
      eventBus.$on("alarmContactGroupSearchName", function(val) {
        tableAlarmContactGroupVue.val = val;
      });
      eventBus.$on("companyId", function(val) {
        tableAlarmContactGroupVue.companyId = val;
      });
      //列表分页
      this.$api.contactGroup
        .pageContactGroup({
          userCompanyId: tableAlarmContactGroupVue.companyId,
          contactGroupName: tableAlarmContactGroupVue.val,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableAlarmContactGroupDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
          // 默认联系人组
          for (var i = 0; i < this.tableAlarmContactGroupDate.length; i++) {
            this.tableAlarmContactGroupDate[i].isDefault = this.isDefaultType[
              this.tableAlarmContactGroupDate[i].isDefault
            ];
          }
        });
    },
    changePage: function(current) {
      this.current = current;
      tableAlarmContactGroupVue.getAlarmContactGroupData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableAlarmContactGroupVue.getAlarmContactGroupData();
    },
    // 销毁alarmContactGroupSearchName
    beforeDestroy: function() {
      eventBus.$off("alarmContactGroupSearchName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.alarmContactGroupName = this.tableAlarmContactGroupDate[index].name;
    },
    removeAlarmContactGroup: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.contactGroup
        .deleteContactGroup(
          "contactGroupId",
          this.tableAlarmContactGroupDate[lineIndex].id
        )
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableAlarmContactGroupVue.getAlarmContactGroupData();
            this.isDisable = false;
            this.modal_loading = false;
            this.alarmContactGroupDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 编辑报警联系人组
    /*************************************************************************/
    // 确定
    editAlarmContactGroupSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 编辑联系人
          this.$api.contactGroup
            .updateContactGroup({
              id: this.alarmContactGroupEditForm.id,
              name: this.alarmContactGroupEditForm.name,
              isDefault: this.alarmContactGroupEditForm.isDefault,
              description: this.alarmContactGroupEditForm.description
            })
            .then(res => {
              this.data = res.data;
              setTimeout(() => {
                tableAlarmContactGroupVue.getAlarmContactGroupData();
                this.$refs[name].resetFields();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success("编辑成功");
                this.alarmContactGroupEditmodal = false;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error("编辑失败");
        }
      });
    },
    // 取消
    editAlarmContactGroupReset: function(name) {
      this.$refs[name].resetFields();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/alarm_contact/alarm_contact_group/TableAlarmContactGroup.vue